import gsap from 'gsap';
import {ScrollToPlugin} from 'gsap/ScrollToPlugin';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

export default class SingleSummary {
    constructor() {
        this.links = document.querySelectorAll('.summary_content a');
        this.select = document.querySelector('.summary_select');

        this.init();
        this.setupScrollTrigger();
        this.setupSelect();
    }

    init() {
        document.querySelectorAll('.summary_content a').forEach((link) => {
            link.addEventListener('click', (e) => this.handleClick(e, link));
        });
    }

    setupSelect() {
        if (!this.select) return;

        this.select.addEventListener('change', (e) => {
            const targetId = e.target.value;
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                gsap.to(window, {
                    duration: 1,
                    scrollTo: {
                        y: targetElement,
                        offsetY: 50,
                    },
                    onComplete: () => {
                        history.replaceState(null, null, ' ');
                    },
                });

                this.setSelectValue(targetId);
            }
        });
    }

    waitForElement(selector, timeout = 1000) {
        return new Promise((resolve, reject) => {
            const element = document.querySelector(selector);
            if (element) return resolve(element);

            const observer = new MutationObserver(() => {
                const el = document.querySelector(selector);
                if (el) {
                    observer.disconnect();
                    resolve(el);
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true,
            });

            setTimeout(() => {
                observer.disconnect();
                reject(`Élément ${selector} introuvable après ${timeout}ms`);
            }, timeout);
        });
    }

    handleClick(event, link) {
        event.preventDefault();
        const targetId = link.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
            gsap.to(window, {
                duration: 1,
                scrollTo: {
                    y: targetElement,
                    offsetY: 50,
                },
                onComplete: () => {
                    history.replaceState(null, null, ' ');
                },
            });
            this.setSelectValue(targetId);
        }
    }

    setupScrollTrigger() {
        this.links.forEach((link) => {
            const targetId = link.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                ScrollTrigger.create({
                    trigger: targetElement,
                    start: 'top top+=15%',
                    end: 'bottom top',
                    onEnter: () => {
                        this.setActiveLink(link);
                        this.setSelectValue(targetId);
                    },
                    onEnterBack: () => {
                        this.setActiveLink(link);
                        this.setSelectValue(targetId);
                    },
                    onLeave: () => this.removeActiveLink(link),
                    onLeaveBack: () => this.removeActiveLink(link),
                });
            }
        });
    }

    setActiveLink(link) {
        document.querySelectorAll('.summary_content_item').forEach((el) => el.classList.remove('active'));
        const li = link.closest('.summary_content_item');
        if (li) li.classList.add('active');
    }

    removeActiveLink(link) {
        const li = link.closest('.summary_content_item');
        if (li) li.classList.remove('active');
    }

    setSelectValue(targetId) {
        if (!this.select || !this.select.niceSelectInstance) return;

        this.select.value = targetId;

        this.waitForElement('.nice-select').then((niceWrapper) => {
            const allOptions = niceWrapper.querySelectorAll('.option');
            let found = false;

            allOptions.forEach((optionEl) => {
                optionEl.classList.remove('selected');
                const optionValue = optionEl.dataset.value?.trim();
                if (optionValue === targetId.trim()) {
                    optionEl.classList.add('selected');

                    const current = niceWrapper.querySelector('.current');
                    if (current) current.textContent = optionEl.textContent.trim();
                }
            });
        });
    }
}
